import { changeofownership as baseChangeofownership } from './baseApi/changeofownership'

export type * from './baseApi/changeofownership'
export {
  ApprovalListSortColumn,
  ApprovalSearchStatusEnum,
  ApprovalStatusEnum,
  ApprovalWhoHandelsItEnum as ApprovalHandler,
  SortOrderEnum,
} from './baseApi/changeofownership'

export const changeofownershipApi = baseChangeofownership.enhanceEndpoints({
  addTagTypes: ['NewOwnerApproval', 'NewOwnerApprovalList'],
  endpoints: {
    postApproval: {
      providesTags: ['NewOwnerApprovalList'],
    },
    getApprovalById: {
      providesTags: (_result, _error, { id }) => [
        { type: 'NewOwnerApproval', id },
      ],
    },
    putApprovalById: {
      invalidatesTags: (_result, error, { id }) =>
        error ? [] : [{ type: 'NewOwnerApproval', id }, 'NewOwnerApprovalList'],
    },
  },
})

export const {
  usePostApprovalQuery,
  useGetApprovalByIdQuery,
  usePutApprovalByIdMutation,
  useGetApprovalApprovalhandlerByClientIdQuery,
} = changeofownershipApi
